<template>
  <span>
    <v-icon v-if="params.isFolder" class="pb-1" :style="cellStyle" :color="iconColor">folder</v-icon>
    <v-icon v-else-if="params.isInsideFolder" class="pb-1" :style="cellStyle" :color="iconColor">subdirectory_arrow_right</v-icon>
    <span class="pl-1">{{params.label}}</span>
  </span>
</template>

<script>
  export default {
    name: 'DocumentViewCellRenderer',
    data() {
    },
    methods: {
    },
    computed: {
      iconColor() {
        return 'var(--v-resBlue-darken1)';
      },
      cellStyle() {
        // indent to show document tree structure
        const offset = 28;
        const maxDisplayDepth = this.params.isFolder ? 9 : 10;
        let depth = this.params.folderDepth || 0;

        if (depth > maxDisplayDepth) {
          depth = maxDisplayDepth; // just stop already
        }
        return `padding-left: ${(depth * offset)}px`;
      }
    },
    mounted() {
      //console.log('LabelCellRenderer'); // uncomment to see how often component is rendering
    }
  }
</script>

<style scoped lang="scss">
</style>
